<app-gold-line [input_position]="'start'" />
<div class="card">
  <div
    class="card__image"
    [style.backgroundImage]="'url(' + singleItem().imageUrl + ')'"
  ></div>
  <ng-container
    *ngIf="languageService.currentLanguage$ | async as currentLanguage"
  >
    @if(currentLanguage == 'Ar'){
    <div class="card__title card__title card__title card__title--ar">
      {{ singleItem().nameAr }}
    </div>
    <div
      class="card__description card__description card__description card__description--ar"
    >
      {{ singleItem().descriptionAr }}
    </div>
    <div class="card__footer">
      <div class="card__price">
        <app-price-user
          [input_price_usdValue]="amountInUSD"
          [input_price_tlValue]="singleItem().priceAr"
          [input_type]="'original'"
        />
      </div>
      <div class="card__counter">
        <app-counter
          [id]="singleItem().id"
          [input_color]="'blue'"
          [price]="singleItem().priceEn"
        />
      </div>
    </div>
    } @else if(currentLanguage == 'En'){
    <div class="card__title">{{ singleItem().nameEn }}</div>
    <div class="card__description">
      {{ singleItem().descriptionEn }}
    </div>
    <div class="card__footer">
      <div class="card__price">
        <app-price-user
          [input_price_usdValue]="amountInUSD"
          [input_price_tlValue]="singleItem().priceEn"
          [input_type]="'original'"
        />
      </div>
      <div class="card__counter">
        <app-counter
          [id]="singleItem().id"
          [input_color]="'blue'"
          [price]="singleItem().priceEn"
        />
      </div>
    </div>
    } @else if(currentLanguage == 'Tr'){
    <div class="card__title">{{ singleItem().nameTr }}</div>
    <div class="card__description">
      {{ singleItem().descriptionTr }}
    </div>
    <div class="card__footer">
      <div class="card__price">
        <app-price-user
          [input_price_usdValue]="amountInUSD"
          [input_price_tlValue]="singleItem().priceEn"
          [input_type]="'original'"
        />
      </div>
      <div class="card__counter">
        <app-counter
          [id]="singleItem().id"
          [input_color]="'blue'"
          [price]="singleItem().priceTr"
        />
      </div>
    </div>
    }
  </ng-container>
</div>
<app-gold-line [input_position]="'end'" />
